export default __webpack_public_path__ + "static/pic5-4e163c00f21112293c2c485476a3eeb3.jpeg";